import { AxiosService } from '../../../../../../services/axiosService';

export const postEmailQueue = data => {
  return AxiosService.post(`/email-queue`, data);
};
